import { render } from "./AppointmentsTab.vue?vue&type=template&id=0a150ecc&scoped=true"
import script from "./AppointmentsTab.vue?vue&type=script&lang=js"
export * from "./AppointmentsTab.vue?vue&type=script&lang=js"

import "./AppointmentsTab.vue?vue&type=style&index=0&id=0a150ecc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a150ecc"

export default script